export default __webpack_public_path__ + "static/media/medication.83d7aa12.svg";